import React, { useEffect, useState, useCallback } from "react";
import { Search, Flag, Eye, FileSignature, Clock3, Send, CheckCircle2, ShieldAlert, Database } from "lucide-react";
import api from "@/lib/api";

const KIND = {
  milestone: { icon: Flag, color: "text-dox-orange" },
  reviewed: { icon: Eye, color: "text-dox-purple" },
  prepared: { icon: FileSignature, color: "text-dox-orange" },
  waiting: { icon: Clock3, color: "text-amber-400" },
  submitted: { icon: Send, color: "text-emerald-400" },
  completed: { icon: CheckCircle2, color: "text-emerald-400" },
  flagged: { icon: ShieldAlert, color: "text-amber-400" },
  learned: { icon: Database, color: "text-dox-magenta" },
  info: { icon: CheckCircle2, color: "text-white/50" },
};

export default function Timeline() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");

  const load = useCallback(async (query) => {
    try { const { data } = await api.get(`/timeline${query ? `?q=${encodeURIComponent(query)}` : ""}`); setItems(data); } catch { /* ignore */ }
  }, []);
  useEffect(() => { load(""); }, [load]);
  useEffect(() => { const t = setTimeout(() => load(q), 300); return () => clearTimeout(t); }, [q, load]);

  return (
    <div className="space-y-6">
      <div>
        <h2 className="font-display font-black text-2xl mb-1">Business Timeline</h2>
        <p className="text-white/55 text-sm">A permanent, searchable history of everything Dox and you have done.</p>
      </div>

      <div className="relative">
        <Search size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-white/40" />
        <input
          data-testid="timeline-search"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Search your history… (e.g. license, insurance, filed)"
          className="w-full bg-surface border border-white/10 rounded-full pl-11 pr-4 py-3 text-sm text-white outline-none focus:border-dox-orange transition"
        />
      </div>

      {items.length === 0 ? (
        <div className="text-center py-12 text-white/40 text-sm">{q ? "No matching history." : "Your history will build here forever."}</div>
      ) : (
        <div className="relative pl-6">
          <div className="absolute left-2 top-1 bottom-1 w-px bg-white/10" />
          <div className="space-y-5">
            {items.map((a) => {
              const k = KIND[a.kind] || KIND.info;
              return (
                <div key={a.id} data-testid={`timeline-${a.id}`} className="relative">
                  <span className="absolute -left-[18px] top-0.5 h-4 w-4 rounded-full bg-ink border-2 border-white/20 flex items-center justify-center">
                    <span className={`h-1.5 w-1.5 rounded-full ${k.color.replace("text-", "bg-")}`} />
                  </span>
                  <div className="flex items-start gap-2">
                    <k.icon size={15} className={`${k.color} mt-0.5 shrink-0`} />
                    <div>
                      <div className="text-sm text-white/85">{a.text}</div>
                      <div className="text-xs text-white/35 mt-0.5">{new Date(a.created_at).toLocaleString()}</div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
